<template>
    <div class="m-subheader ">
        <div class="d-flex align-items-center">
            <div class="mr-auto">
                <h3 class="m-subheader__title m-subheader__title--separator">
                    <slot name="title"></slot>
                </h3>
                <slot name="links"></slot>
            </div>
            <div class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push" data-dropdown-toggle="hover" aria-expanded="true">
                <div class="m-portlet__foot m-portlet__foot--fit">
                    <div class="m-form__actions">
                        <slot name="actions"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "BreadCrumb"
};
</script>




// WEBPACK FOOTER //
// src/components/partials/BreadCrumb.vue